module.exports = __webpack_public_path__ + "img/close.631b0baa.webp";